import {
  Card,
  Input,
  Button,
  Typography,
  Textarea,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import Navbar from "../../component/Navbar";
import { dataPost } from "../../network";
import { postData, nmsLocations, nmsSync } from "../../network/const";
import { Dialog } from "../../component/items/Dialog";
import { dialogDataTypes } from "../../component/items/itemDataType";
import { useState, useEffect, useRef } from "react";
import axios from "axios";

export function LoadData() {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    btnText: "",
    description: "",
  });
  const [formState, setFormState] = useState({
    email: "notam@info.com",
    identification: "",
    data: "",
  });

  // NMS State
  const [locations, setLocations] = useState<any[]>([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocationDesc, setSelectedLocationDesc] = useState("");
  const [syncLoading, setSyncLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleChange = (e: any) => {
    setFormState({ ...formState, [e.target.id]: e.target.value });
  };
  const initDialog = (data: dialogDataTypes) => {
    setOpen(true);
    setDialogData({
      title: data.title,
      btnText: data.btnText,
      description: data.description,
    });
  };

  const fetchLocations = async (search = "") => {
    try {
      const response = await axios.get(nmsLocations, {
        params: { search, limit: 50 },
      });
      // API returns { count: number, rows: [] }
      setLocations(response.data.rows || []);
    } catch (error) {
      console.error("Failed to fetch locations", error);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  // Debounce search
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchLocations(searchTerm);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelectLocation = (loc: any) => {
    setSelectedLocation(loc.locationId);
    setSelectedLocationDesc(loc.description);
    setSearchTerm(`${loc.locationId} - ${loc.description}`);
    setShowDropdown(false);
  };

  const syncNmsData = async () => {
    if (!selectedLocation) return;
    setSyncLoading(true);

    const response = await dataPost(
      nmsSync,
      {
        locationId: selectedLocation,
      },
      { silent: false }
    );

    if (response.status) {
      const count = response.data.count;
      let message = "";
      if (count > 0) {
        message = `${count} NOTAM(s) successfully synced for aerodrome ${selectedLocationDesc} (${selectedLocation}).`;
      } else {
        message = `No active NOTAMs were found for aerodrome ${selectedLocationDesc} (${selectedLocation}) at this time.`;
      }

      initDialog({
        title: response.title,
        description: message,
        btnText: "OK",
      });
    } else {
      initDialog({
        title: response.title || "Sync Failed",
        description: response.message || "Unknown error",
        btnText: "OK",
      });
    }
    setSyncLoading(false);
  };

  const submitData = async () => {
    const data = await dataPost(postData, formState);

    if (data.status) {
      initDialog({
        description: data.message,
        title: data.title,
        btnText: "OK",
      });
      // setFormState({ email: "notam@info.com", identification: "", data: "" });
    } else {
      // initDialog({
      //   description: data.message,
      //   title: data.title,
      //   btnText: "OK",
      // });

      console.error("NOTAM submission failed:", data.message);

      // Dialog showing invalid NOTAM specifically
      initDialog({
        description: data.message.includes("Invalid NOTAM format")
          ? `NOTAM Validation Failed:\n${data.message}`
          : data.message,
        title: data.title || "Error",
        btnText: "OK",
      });

      //  Optional: set visual error state (e.g., red border)
    }
  };
  return (
    <>
      <Navbar />
      <div className="pt-24 pb-10 px-4 w-full min-h-screen bg-gray-50">
        <div className="container mx-auto max-w-6xl">
          {/* Two-column layout */}
          <div className="flex flex-col lg:flex-row gap-8 items-start justify-center">
            {/* Left: Form */}
            <Card
              shadow={true}
              className="w-full lg:flex-1 p-6 min-h-[500px] !overflow-visible"
              style={{ overflow: "visible" }}
            >
              <Typography
                variant="h4"
                color="blue-gray"
                className="text-center mb-6"
              >
                Load Data
              </Typography>

              <Tabs value="manual" className="overflow-visible">
                <TabsHeader>
                  <Tab value="manual">Manual Entry</Tab>
                  <Tab value="nms">FAA NOTAMs</Tab>
                </TabsHeader>
                <TabsBody
                  className="!overflow-visible"
                  style={{ overflow: "visible" }}
                >
                  <TabPanel value="manual" className="px-0">
                    <Typography
                      color="gray"
                      className="text-center mb-6 font-normal"
                    >
                      Please fill in the NOTAM data below
                    </Typography>
                    <form className="flex flex-col gap-6">
                      <Input
                        size="lg"
                        label="Identification"
                        id="identification"
                        crossOrigin={undefined}
                        onChange={handleChange}
                        value={formState.identification}
                      />
                      <Textarea
                        label="Insert NOTAM data here"
                        rows={10}
                        id="data"
                        onChange={handleChange}
                        value={formState.data}
                      />
                      <Button
                        fullWidth
                        onClick={submitData}
                        disabled={!formState.identification || !formState.data}
                      >
                        Submit Data
                      </Button>
                    </form>
                  </TabPanel>
                  <TabPanel
                    value="nms"
                    className="px-0 !overflow-visible"
                    style={{ overflow: "visible" }}
                  >
                    <Typography
                      color="gray"
                      className="text-center mb-6 font-normal"
                    >
                      Select an Aerodrome to FAA NOTAMs
                    </Typography>
                    <div className="flex flex-col gap-6 relative">
                      <div className="relative" ref={wrapperRef}>
                        <Input
                          label="Search & Select Location"
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setShowDropdown(true);
                            setSelectedLocation(""); // Reset selection on type
                          }}
                          onFocus={() => setShowDropdown(true)}
                          crossOrigin={undefined}
                        />
                        {showDropdown && locations.length > 0 && (
                          <Card className="absolute top-full mt-1 left-0 w-full max-h-60 overflow-y-auto z-50 shadow-xl border border-blue-gray-100 rounded-md">
                            <ul className="flex flex-col p-1">
                              {locations.map((loc: any) => (
                                <li
                                  key={loc.locationId}
                                  className="px-4 py-2 hover:bg-blue-50 cursor-pointer rounded-md text-sm transition-colors"
                                  onClick={() => handleSelectLocation(loc)}
                                >
                                  <span className="font-bold text-blue-gray-900">
                                    {loc.locationId}
                                  </span>{" "}
                                  <span className="text-gray-600">
                                    - {loc.description}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </Card>
                        )}
                      </div>
                      <Button
                        fullWidth
                        onClick={syncNmsData}
                        disabled={!selectedLocation || syncLoading}
                        className="mt-2"
                      >
                        {syncLoading ? "Syncing..." : "FAA NOTAMs"}
                      </Button>
                    </div>
                  </TabPanel>
                </TabsBody>
              </Tabs>
            </Card>

            {/* Right: Note Card */}
            <Card
              shadow={false}
              className="w-full lg:w-[400px] p-6 bg-blue-50 border border-blue-100 rounded-xl"
            >
              <Typography
                variant="h6"
                color="blue"
                className="mb-4 flex items-center gap-2"
              >
                <span>⚠️</span> Instructions
              </Typography>
              <Typography
                variant="small"
                color="blue-gray"
                className="text-xs whitespace-pre-line leading-relaxed opacity-80 font-medium"
              >
                Only Full ICAO NOTAM Format with brackets is accepted.
                {"\n\n"}✅ Single NOTAM Example:
                {"\n"}(A1736/25 NOTAMN
                {"\n"}Q)OMAE/QWULW/IV/BO/AW/000/003/2427N05435E001
                {"\n"}A)OMAA B)2506220700 C)2506221000
                {"\n"}E)UAS ACT WILL TAKE PLACE WI AREA BOUNDED BY LINES
                JOINING:
                {"\n"}242648.59N 0543505.60E
                {"\n"}242650.56N 0543517.50E
                {"\n"}242642.68N 0543520.28E
                {"\n"}242640.57N 0543508.23E
                {"\n"}242648.59N 0543505.60E
                {"\n"}F)SFC G)100FT AGL)
                {"\n\n"}✅ Multiple NOTAMs Example (up to 10 in one submission):
                {"\n"}(A1736/25 NOTAMN
                {"\n"}Q)OMAE/QWULW/IV/BO/AW/000/003/2427N05435E001
                {"\n"}A)OMAA B)2506220700 C)2506221000
                {"\n"}E)UAS ACT WILL TAKE PLACE WI AREA BOUNDED BY LINES
                JOINING:
                {"\n"}242648.59N 0543505.60E
                {"\n"}242650.56N 0543517.50E
                {"\n"}242642.68N 0543520.28E
                {"\n"}242640.57N 0543508.23E
                {"\n"}242648.59N 0543505.60E
                {"\n"}F)SFC G)100FT AGL)
                {"\n\n"}(A1737/25 NOTAMN
                {"\n"}Q)OMDB/QWULW/IV/BO/W/000/008/231402N0723746E001
                {"\n"}A)OMDB B)2509210000 C)2509212359
                {"\n"}E)UAS ACT WILL TAKE PLACE WI AREA BTN FLW POINTS:
                {"\n"}231402.00N 0723746.00E
                {"\n"}231420.00N 0723950.00E
                {"\n"}231430.00N 0723740.00E
                {"\n"}F)SFC G)800FT AGL)
                {"\n\n"}👉 Each NOTAM must start with (AXXXX/YY NOTAM...) in
                ICAO format.
                {"\n"}👉 Max 10 NOTAMs allowed per submission.
                {"\n"}👉 Duplicate NOTAM numbers will be skipped automatically.
              </Typography>
            </Card>
          </div>

          {/* Dialog */}
          <Dialog
            open={open}
            handleOpen={() => setOpen(!open)}
            title={dialogData.title}
            description={dialogData.description}
            buttonText={dialogData.btnText}
          />
        </div>
      </div>
    </>
  );
}
